/**
 * Ultrasounds Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";

// States
const state = {
    ultrasounds: [],
    ultrasound: {}
};

// Getters
const getters = {
    ultrasounds: state => {
        return state.ultrasounds
    },

    ultrasound: state => {
        return state.ultrasound
    }
};

// Actions
const actions = {
    getUltrasounds(context, payload) {
        function successCallback(response) {
            context.commit('getUltrasoundsHandler', { ultrasounds: response.data.echographies });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Ultrasound.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getUltrasound(context, payload) {
        function successCallback(response) {
            context.commit('getUltrasoundHandler', { ultrasound: response.data.echographie });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Ultrasound.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createUltrasound(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'ultrasound', params: { ultrasound: response.data.echographie.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Ultrasound.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateUltrasound(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'ultrasound' });

            router.push({ name: 'ultrasound', params: { ultrasound: response.data.echographie.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Ultrasound.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteUltrasound(context, payload) {
        function successCallback(response) {
            context.commit('deleteUltrasoundHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Ultrasound.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getUltrasoundsHandler(state, { ultrasounds }) {
        // Update ultrasounds state
        state.ultrasounds = ultrasounds;
    },

    getUltrasoundHandler(state, { ultrasound }) {
        // Update ultrasound state
        state.ultrasound = ultrasound;
    },

    deleteUltrasoundHandler(state, { index, successMessage }) {
        let i = state.ultrasounds.findIndex(ultrasound => ultrasound.slug === index);

        if (~i) {
            state.ultrasounds.splice(i, 1);

            router.push({ name: 'ultrasounds' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}